import { Navigate } from 'react-router-dom';
import jwt from 'utils/jwt';

const ProtectedRoute = (props: any) => {
  return !!jwt.get() ? props.children : <Navigate to="/login" />;
};

export default ProtectedRoute;
